/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

// import DoubleImageParallax from './scripts/double-image-parallax';
import ElementInView from './scripts/element-in-view';
import PageStatus from './scripts/page-status';
import MenuToggle from './scripts/menu-toggle';
import ScrollableContent from './scripts/scrollable-content';
import ShareMenu from './scripts/share-menu';
import Accordion from './scripts/accordion';
import FooterToggle from './scripts/footer-toggle';
import NewsletterModal from './scripts/newsletter-modal';
import CookiebotToggle from './scripts/cookiebot-toggle';

const scripts = [
  PageStatus,
  MenuToggle,
  ScrollableContent,
  Accordion,
  // DoubleImageParallax,
  FooterToggle,
  ElementInView,
  ShareMenu,
  NewsletterModal,
  CookiebotToggle
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
